// FAQ.js
import React, { useState } from "react";
import "./InternalPages.scss";

import { MdKeyboardArrowDown } from "react-icons/md";
import { MdOutlineKeyboardArrowUp } from "react-icons/md";

const faqs = [
  {
    question: "What do I need to sign up for a business account?",
    answer:
      "To get started, you simply need to provide your business name, GST number, mobile number, and pickup location details. Once submitted, our team verifies your info and activates your enterprise account within 24 hours — no hidden setup fees or paperwork hassles.",
  },
  { question: "How do recurring orders work?", answer: "" },
  { question: "Can I track multiple deliveries and vehicles at once?", answer: "" },
  { question: "Can I deliver to multiple customers in one trip?", answer: "" },
  { question: "Can I give my team access to manage bookings?", answer: "" },
  { question: "How is pricing calculated for deliveries?", answer: "" },
  { question: "What vehicle options are available for different parcel sizes?", answer: "" },
  { question: "Can I download invoices and reports for accounting?", answer: "" },
  { question: "Is there support for urgent or same-day deliveries?", answer: "" },
  { question: "What if I need help or face an issue during delivery?", answer: "" },
];

function FAQ() {
  const [openIndex, setOpenIndex] = useState(0);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="faq-container">
     <h2 className="fw-100 d-flex justify-content-center mb-5">Frequently Asked Questions</h2>
      <div className="faq-list">
        {faqs.map((faq, index) => (
          <div
            className={`faq-item ${openIndex === index ? "open" : ""}`}
            style={{
              background: openIndex === index ? "#fcf7e7": null,
              borderRadius: openIndex === index ?'10px': null,
              borderBottom: openIndex === index ?  'none' : '1px solid #d8d8d8',
            }}
            key={index}
            onClick={() => toggleFAQ(index)}
          >
            <div className="faq-question">
              {faq.question}
              <span className="faq-icon">{openIndex === index ? <MdOutlineKeyboardArrowUp style={{fontSize: '24px'}}/> : <MdKeyboardArrowDown style={{fontSize: '24px'}} />}</span>
            </div>
            {openIndex === index && (
              <div className="faq-answer py-4 mx-3">
                {faq.answer || <em>Answer coming soon...</em>}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}

export default FAQ;
